import { render, staticRenderFns } from "./NfreshDeleteSub.vue?vue&type=template&id=38ed47e7&scoped=true&"
import script from "./NfreshDeleteSub.vue?vue&type=script&lang=ts&"
export * from "./NfreshDeleteSub.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ed47e7",
  null
  
)

export default component.exports